// extracted by mini-css-extract-plugin
export default {"wrapper":"SkillContainer_wrapper__jLpOx","title":"SkillContainer_title__kYj7w","container":"SkillContainer_container__aXejk","centered":"SkillContainer_centered__hSrvA"};